/* eslint-disable */

import type { SimulateContractParameters } from "@wagmi/core"
import type { Config } from "wagmi"
import type { Hash } from "viem"
import { simulateContract, waitForTransactionReceipt, writeContract } from "@wagmi/core"

import type { TransactionReceiptWaitOptions, TransactionReturnType } from "./types"

type SimulatedTransactionProps = {
  config: Config
  simulateArgs: SimulateContractParameters
  gas?: bigint
  receiptWait?: TransactionReceiptWaitOptions
}

/**
 * Repetitive code used in many places to simulate and execute a function on a contract
 * @param param0
 * @returns
 */
export const simulatedTransaction = async ({
  config,
  simulateArgs,
  gas,
  receiptWait,
}: SimulatedTransactionProps): Promise<TransactionReturnType> => {
  let hash: Hash | undefined

  try {
    console.log()
    console.log()
    console.log(`🚀 ${simulateArgs.functionName}`)
    const simulated = await simulateContract(config, simulateArgs)
    console.log(`🤖 ${simulateArgs.functionName}→simulated`, simulated)

    const writeRequest = { ...simulated.request }
    if (gas) {
      writeRequest.gas = gas
    }

    console.log(`🕵🏻‍♂️ ${simulateArgs.functionName}→writeRequest`, writeRequest)

    hash = await writeContract(config, writeRequest)
    console.log(`⚡️ ${simulateArgs.functionName}→tx`, hash)

    try {
      console.log(`⌛ ${simulateArgs.functionName}→waiting for transaction receipt`)
      const transaction = await waitForTransactionReceipt(config, { hash, ...receiptWait })
      console.log(`✅ ${simulateArgs.functionName}→transaction`, transaction)
      console.log()
      console.log()
      return {
        tx: hash,
        success: true,
        simulatedResult: simulated.result,
        transaction,
      }
    } catch (error: any) {
      if (
        typeof error?.message === "string" &&
        /the transaction may not be processed on the block yet/i.test(error?.message)
      ) {
        console.log(
          `❗ ${simulateArgs.functionName}→transaction not found, it may not be processed on the block yet. retrying...`,
        )
        const transaction = await waitForTransactionReceipt(config, { hash, ...receiptWait })
        console.log(`✅ ${simulateArgs.functionName}→transaction`, transaction)
        console.log()
        console.log()
        return {
          tx: hash,
          success: true,
          simulatedResult: simulated.result,
          transaction,
        }
      }
      throw error
    }
  } catch (error: any) {
    console.log(`❗ ${simulateArgs.functionName}->error`)
    if (isUserRejectedRequest(error)) {
      console.log(`User rejected ${String(simulateArgs.functionName)} transaction`)
    } else {
      console.error(error)
    }
    console.log()
    console.log()
    return { success: false, error: error.message, code: error.code, tx: hash }
  }
}

function isUserRejectedRequest(error: unknown): boolean {
  if (!(error instanceof Error)) return false
  return /user (rejected|denied)|request rejected|ACTION_REJECTED/i.test(error.message)
}
